import { createFileRoute } from '@tanstack/react-router';

import { PublicEnrollPage } from '@/features/student-portal/PublicEnrollPage';

export const Route = createFileRoute('/enroll/$courseId/$sessionId')({
  component: PublicEnrollPage,
});
